import React from 'react';
import { PageContainer } from '../Styles/AppStyles';
import { Header } from '../Components/Header/Header';

const NonAbatixPage: React.FC = () => {
  return (
    <PageContainer>
      <Header title="Non-Abatix" hideCount />
    </PageContainer>
  );
};

export default NonAbatixPage;
